import {
  CapabilitiesTile,
  ComponentSelector,
  EventCountdownTimer,
  HeroFlattenImage,
  HomeDecorCard,
  Image,
  PiccolaPencil,
  QuickLinks,
  MedioInline,
  LoyaltyBenefits,
  NewspaperModule,
  OnlineWorkshops,
  PersonalizedHomeServices,
  PopularCategories,
  PrivateLabelCreditCard,
  ProductShelf,
  PromotionCard,
  PromoVisualNavigation,
  Quotes,
  RecentOrders,
  RecentPurchases,
  Recommendations,
  SectionSelector,
  ShopByCategory,
  SignIn,
  SpecialBuyOfTheDay,
  SpecialBuyOfTheWeek,
  SponsoredBanner,
  Spotlight,
  SpotlightContainer,
  UserList,
  VisualNavigation,
  WelcomeMessage,
  BentoHero
} from '.';

export const components = {
  CapabilitiesTile,
  ComponentSelector,
  EventCountdownTimer,
  HeroFlattenImage,
  HomeDecorCard,
  Image,
  PiccolaPencil,
  AnchorLinks: QuickLinks,
  MedioInline,
  LoyaltyBenefits,
  Newspaper: NewspaperModule,
  OnlineWorkshops,
  PersonalizedHomeServices,
  PopularCategories,
  PrivateLabelCreditCard,
  ProductShelf,
  PromotionCard,
  PromoVisualNavigation,
  RecentOrders,
  RecentPurchases,
  Recommendations,
  Section: SectionSelector,
  ShopByCategory,
  SignIn,
  SpecialBuyOfTheDay,
  SpecialBuyOfTheWeek,
  SponsoredBanner,
  Spotlight,
  SpotlightContainer,
  UserList,
  VisualNavigation,
  welcomeMessage: WelcomeMessage,
  BentoHero,
  Quotes
};
